import { render } from "./IconError.vue?vue&type=template&id=8044372e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8044372e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8044372e', __exports__)) {
    api.reload('8044372e', __exports__)
  }
  
  module.hot.accept("./IconError.vue?vue&type=template&id=8044372e", () => {
    api.rerender('8044372e', render)
  })

}


export default __exports__